import { render, staticRenderFns } from "./email-activation.vue?vue&type=template&id=112c839b&"
import script from "./email-activation.vue?vue&type=script&lang=ts&"
export * from "./email-activation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports